import { Pipe, PipeTransform } from '@angular/core';
import { SeasonalityCategory } from '../Model/SeasonalityCategory';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'seasonalityCatFilter',
  standalone: false
})
export class SeasonalityCategoryFilterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(seasonalities: SeasonalityCategory[], searchTerm: string, field: string): SeasonalityCategory[] {
    if (!seasonalities || !searchTerm) return seasonalities;

    const lowerSearchTerm = searchTerm.toLowerCase();

    return seasonalities.filter(seasonality =>
      this.matchesSearchTerm(seasonality, lowerSearchTerm)
    );
  }

  private matchesSearchTerm(seasonality: SeasonalityCategory, term: string): boolean {
    return (
      this.stringMatches(seasonality.seasonalityCategoryCode, term) ||
      this.stringMatches(seasonality.seasonalityCategoryLabel, term) ||
      this.stringMatches(seasonality.UserName, term) ||
      this.dateMatches(seasonality.applicationDate, term)
    );
  }

  private stringMatches(value: string | null | undefined, term: string): boolean {
    return value?.toLowerCase().includes(term) ?? false;
  }

  private dateMatches(date: string | number | Date | null | undefined, term: string): boolean {
    if (!date) return false;
    const formattedDate = this.datePipe.transform(date as string | number | Date, 'MMMM dd, yyyy');
    return formattedDate?.toLowerCase().includes(term) ?? false;
  }
}
